import { render, staticRenderFns } from "./bank-account-detail.vue?vue&type=template&id=d7f66636"
import script from "./bank-account-detail.vue?vue&type=script&lang=js"
export * from "./bank-account-detail.vue?vue&type=script&lang=js"
import style0 from "./bank-account-detail.vue?vue&type=style&index=0&id=d7f66636&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports